import React, { useState, useRef, useEffect } from "react";
import BFIT_LOGO from "../../assets/images/bfit_logo.svg";
import BFIT_LOGO_ONLY from "../../assets/images/bfit_logo_only.svg";
import { UncontrolledAlert } from "reactstrap";
import { useImmer } from "use-immer";
import banjosApi from "../../api/banjosApi";
import { useHistory } from "react-router";
import { version } from "../../../package.json";
// material
import { styled } from "@mui/material/styles";
import {
  Box,
  Card,
  Stack,
  Link,
  Alert,
  Tooltip,
  Container,
  Typography,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";
import SimpleReactValidator from "simple-react-validator";
import Page from "../../components/Page";
import { getTenantId } from "../../helper/Common";

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

export const Auth = () => {
  const [, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
    })
  );
  const history = useHistory();
  const [auth, setAuth] = useImmer({
    isBusy: false,
    errors: "",
    tenant: "",
    data: {
      playerCode: "",
    },
  });

  useEffect(() => {
    if (getTenantId()) {
      window.location.href = "device/config";
    }
  }, []);

  const onLogin = (e) => {
    if (e) e.preventDefault();
    setAuth((draft) => {
      draft.isBusy = true;
    });
    banjosApi
      .post("default/validate-player", auth.data)
      .then((res) => {
        setAuth((draft) => {
          draft.errors = "";
          draft.isBusy = false;
          draft.tenant = res.data;
        });
        localStorage.setItem("tid", res.data);
        window.location.href = "device/config";
        // history.push("device/config");
      })
      .catch((err) => {
        setAuth((draft) => {
          draft.isBusy = false;
          draft.errors = err.response
            ? err.response.data.message
            : "Unable to connect";
        });
      });
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    setAuth((draft) => {
      draft.data[name] = value;
    });
  };
  return (
    <RootStyle title="Login">
      {/* <MHidden width="mdDown"> */}
      <SectionStyle>
        <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}></Typography>
        <Box component={"img"} sx={{ p: 10 }} src={BFIT_LOGO} width="100" />
      </SectionStyle>
      {/* </MHidden> */}

      <Container maxWidth="sm">
        <ContentStyle>
          <form
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              if (validator.current.allValid()) {
                onLogin();
              } else {
                validator.current.showMessages();
                forceUpdate(1);
              }
            }}
          >
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h4" gutterBottom>
                  Welcome to bfitds
                </Typography>
                <Typography sx={{ color: "text.secondary" }}>
                  Please enter your player code to continue...
                </Typography>
                {/* <Box
                component="img"
                src={BFIT_LOGO_ONLY}
                sx={{ width: 32, height: 32 }}
              /> */}
              </Box>
            </Stack>
            <Stack spacing={3}>
              {auth.errors && <Alert severity="error">{auth.errors}</Alert>}
              <TextField
                autoFocus
                name="playerCode"
                label="Player Code"
                disabled={auth.isBusy}
                onChange={onChange}
                value={auth.data.playerCode}
                error={validator.current.message(
                  "playerCode",
                  auth.data.playerCode,
                  "required"
                )}
                helperText={validator.current.message(
                  "playerCode",
                  auth.data.playerCode,
                  "required"
                )}
              />
            </Stack>
            <LoadingButton
              sx={{ mt: 2 }}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              loading={auth.isBusy}
            >
              Continue
            </LoadingButton>
            <Typography sx={{ mt: 2 }} textAlign="center">
              v {version}
            </Typography>
          </form>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
  // return (
  //   <div className="app app-login p-0">
  //     <div className="row g-0 app-auth-wrapper">
  //       <div className="col-12 col-md-5 col-lg-6 h-100 auth-background-col">
  //         <div className="auth-background-holder"></div>
  //         <div className="auth-background-mask" />
  //         <div className="auth-background-overlay p-3 p-lg-5">
  //           <div className="d-flex flex-column align-content-end h-100">
  //             <div className="h-100" />
  //           </div>
  //         </div>
  //       </div>

  //       <div className="col-12 col-md-7 col-lg-6 auth-main-col p-5">
  //         <div className="d-flex flex-column align-content-end justify-content-center h-100">
  //           <div className="app-auth-body mx-auto">
  //             <div className="app-auth-branding mb-4">
  //               <a className="app-logo" href="/login">
  //                 <img className="logo-icon mr-2" src={BFIT_LOGO} alt="logo" />
  //               </a>
  //             </div>
  //             <h2 className="auth-heading mb-5">
  //               Welcome to bfitds,
  //               <br /> Please enter your player code to continue...
  //             </h2>

  //             <div className="auth-form-container text-left">
  //               {auth.errors && (
  //                 <UncontrolledAlert
  //                   color="warning"
  //                   className="col-md-6"
  //                   dismissable
  //                   toggle={() =>
  //                     setAuth((draft) => {
  //                       draft.errors = "";
  //                     })
  //                   }
  //                 >
  //                   {auth.errors}
  //                 </UncontrolledAlert>
  //               )}
  //               <form className="auth-form login-form" onSubmit={onLogin}>
  //                 <div className="email mb-3">
  //                   <lable>Player code</lable>
  //                   <div className="col-md-6">
  //                     <input
  //                       value={auth.data.playerCode}
  //                       name="playerCode"
  //                       className="form-control"
  //                       required
  //                       onChange={onChange}
  //                     />
  //                   </div>
  //                   <div className="mt-3">
  //                     <div className="col-md-6">
  //                       <LoadingButton
  //                         fullWidth
  //                         size="large"
  //                         type="submit"
  //                         variant="contained"
  //                         loading={auth.isBusy}
  //                       >
  //                         Continue
  //                       </LoadingButton>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </form>
  //             </div>
  //           </div>
  //           <footer className="app-auth-footer">
  //             {/* <div className="container py-3">
  //               <small className="copyright">&copy; bfit</small>
  //             </div> */}
  //           </footer>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
};
